module.exports = __webpack_public_path__ + "img/bg_double.bed1661f.svg";